import { some } from 'lodash';
import componentServices from '../componentServices';
import { IEmployee } from '../models/employeeModel';
import { IUser } from '../models/userModel';

export interface ISecurityContext {
	getCurrentUser(): IUser;
	getCurrentEmployee(): IEmployee;
	isAdminOrCurrentEmployee(employeeKey: string): boolean;
	isCurrentEmployee(employeeKey: string): boolean;
	currentUserHasModule(module: string): boolean;
	currentUserHasFeature (module: string, feature: string, explicit?: boolean): boolean;
}

// Note: factory parameters are accessor functions
const securityContext = function (store) {
	const instance = {
		getCurrentUser () {
			return store().getIn(['viewState', 'currentUser']);
		},
		getCurrentEmployee () {
			return store().getIn(['viewState', 'currentEmployee']);
		},
		isCurrentEmployee(employeeKey: string) {
			const currentEmployee = instance.getCurrentEmployee();

			return currentEmployee && currentEmployee.key === employeeKey;
		},
		isAdminOrCurrentEmployee(employeeKey: string) {
			const user = instance.getCurrentUser();

			return user && (user.hasModule('system-admin')) || instance.isCurrentEmployee(employeeKey);
		},
		currentUserHasModule (module) {
			const user = instance.getCurrentUser();

			return !!user && user.hasModule(module)
		},
		currentUserHasFeature (module, feature, explicit) {
			const user = instance.getCurrentUser();
			const modules = store().getIn(['model', 'domainEntities']).modules;

			return !!user && some(modules, m => m.key === module && some(m.features, { key: feature })) && user.hasFeature(module, feature, explicit);
		}
	};

	return instance;
};

componentServices.set('securityContext', securityContext, ['store']);